/**
 * Full-screen overlay shown while a GET / data fetch is in progress.
 * Displays a progress message and a sports-themed emoji dance (racquets, balls, nets, cups, etc.).
 */

import React from 'react';
import './DataFetchOverlay.css';

const SPORTS_EMOJIS = ['🏓', '🎾', '⚽', '🏀', '🏐', '🏆', '🥇', '🥈', '🏸', '🎱'];

export default function DataFetchOverlay({ message = 'Loading…', className = '' }) {
  return (
    <div
      className={`data-fetch-overlay ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={message}
    >
      <div className="data-fetch-overlay-backdrop" aria-hidden />
      <div className="data-fetch-overlay-content">
        <div className="data-fetch-overlay-emoji-dance" aria-hidden>
          {SPORTS_EMOJIS.map((emoji, i) => (
            <span
              key={i}
              className="data-fetch-overlay-emoji"
              style={{ '--emoji-index': i }}
            >
              {emoji}
            </span>
          ))}
        </div>
        <p className="data-fetch-overlay-message">{message}</p>
      </div>
    </div>
  );
}
